import previewDarkModeTheme from './previewDarkModeTheme';
import getIsDarkModeEnabledInUserSettings from '../selectors/getIsDarkModeEnabledInUserSettings';
export default function discardDarkModeOption() {
    previewDarkModeTheme(getIsDarkModeEnabledInUserSettings());
}
//# sourceMappingURL=discardDarkModeOption.js.map